import { createStore } from '@orderx/lab/xr/store';
import { MenuProduct } from '../XV2';

interface Store {
    category: string;
    subCategory: string;
}

const { useStore, reset } = createStore<Store>({
    category: '',
    subCategory: '',
});

export function useMenuProductCategory() {
    const [state, setState] = useStore();

    function toggle(field, value) {
        setState((state) => {
            state[field] = state[field] === value ? '' : value;
        });
    }

    function setCategory(category) {
        toggle('category', category);

        setState((state) => {
            state.subCategory = '';
        });
    }

    return {
        category: state.category,
        subCategory: state.subCategory,
        isMyOrderActive() {
            return state.category === 'MY_ORDER';
        },
        setCategory: setCategory,
        setSubCategory(subCategory) {
            toggle('subCategory', subCategory);
        },
        reset: reset,
        filterProducts(menuProducts: MenuProduct[]) {
            return menuProducts.filter(({ product }) => {
                if (state.category && product.category !== state.category) {
                    return false;
                }

                return !(state.subCategory && product.subCategory !== state.subCategory);
            });
        },
        toggleActiveOrder() {
            setCategory('MY_ORDER');
        },
    };
}
